import * as R from 'ramda';

import colors from '@atom/styles/colors';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import { schema } from './collinsMpcConstants';
import {
  getAttributeDataRows,
  getNestedElementDisplayRows,
} from './collinsMpcUtilities';

import classes from './collinsMpcPdfReport.module.css';

interface Props {
  element: any;
  mediaDictionary: any;
}

const NestedElement = ({ element, mediaDictionary }: Props) => {
  const attributes = getAttributeDataRows(
    element?.attributes,
    R.pathOr([], ['attributeGroups', 0, 'attributes'], element),
  );
  const filteredAttributes = attributes.filter(
    attribute => attribute.id !== schema.poolAttributes.description,
  );

  const media = mediaDictionary[element?.id];

  const descriptionText = R.pathOr(
    null,
    ['attributes', schema.poolAttributes.description, 'value'],
    element,
  );

  const displayRows = getNestedElementDisplayRows(filteredAttributes, media);

  return (
    <div className={classes.sectionBox}>
      <div className={classes.sectionTitle}>{element?.name}</div>
      {descriptionText && (
        <div className={classes.elementDescription}>
          <div className={classes.descriptionTitle}>Description:</div>
          <div>{descriptionText}</div>
        </div>
      )}
      {displayRows.map(item => {
        return (
          <div className={classes.elementRow}>
            {item.map((displayItem, index) => {
              const style = {
                borderRight:
                  index === 0 ? `2px solid ${colors.neutral.silver}` : 'none',
              };

              const photoStyle = {
                backgroundImage: `url('${FILES_ENDPOINT}/${displayItem?.fileId}_1440')`,
              };

              return displayItem.isMedia ? (
                <div style={style} className={classes.photoBox}>
                  <div className={classes.photo} style={photoStyle} />
                </div>
              ) : (
                <div style={style} className={classes.elementDisplayBox}>
                  {displayItem?.attributes.map(attribute => {
                    return (
                      <div className={classes.dataRow} key={attribute?.id}>
                        <div
                          className={classes.dataTitle}
                        >{`${attribute?.name}:`}</div>
                        <div className={classes.dataContent}>
                          {attributeDisplayUtility.display(
                            attribute.value,
                            attribute.dataType,
                            attribute.unit,
                            !!attribute.changeId,
                            attribute.newValue,
                            attribute.thousandsSeparator,
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default NestedElement;
